class StorageManager {
    DARK_MODE_EVENT = 'dark-mode';
    constructor() {
        this.element = $(document);
        this.storage = window.localStorage;
    }

    setDarkMode(value) {
        this.storage.setItem('rmpl:dark-mode', value);
        this.element.trigger(this.DARK_MODE_EVENT, value)
    }

    getDarkMode() {
        return this.storage.getItem('rmpl:dark-mode');
    }

    clearDarkMode() {
        this.storage.removeItem('rmpl:dark-mode');
        setTimeout(() => {
            this.element.trigger(this.DARK_MODE_EVENT, false)
        }, 1000)
    }
}

const storageManager = new StorageManager();

export default storageManager;


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/storage-manager.js